import React, { useEffect, useState } from "react";
import { api, inr } from "@/lib/api";
import { Package, ClipboardList, Users, IndianRupee } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="text-hyd-text2">Loading dashboard...</div>;
  const cards = [
    { label: "Revenue", value: inr(stats.revenue), icon: IndianRupee, accent: "text-hyd-gold" },
    { label: "Orders", value: stats.total_orders, icon: ClipboardList, accent: "text-hyd-red" },
    { label: "Products", value: stats.total_products, icon: Package, accent: "text-hyd-gold" },
    { label: "Customers", value: stats.total_customers, icon: Users, accent: "text-hyd-red" },
  ];
  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold">Dashboard</h1>
      <p className="text-hyd-text2 text-sm">Business at a glance</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-5">
        {cards.map((c) => (
          <div key={c.label} className="bg-hyd-panel border border-hyd-border rounded-xl p-4 relative overflow-hidden">
            <div className={`absolute top-0 left-0 right-0 h-1 ${c.accent.replace("text-", "bg-")}`} />
            <div className="flex justify-between items-start">
              <div>
                <div className="text-xs uppercase tracking-widest text-hyd-text2">{c.label}</div>
                <div className={`text-2xl font-bold ${c.accent} mt-1 font-display`}>{c.value}</div>
              </div>
              <c.icon className={`w-5 h-5 ${c.accent}`} />
            </div>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-6">
        <div className="bg-hyd-panel border border-hyd-border rounded-xl p-4">
          <h3 className="font-display text-lg font-bold mb-3">Orders by status</h3>
          <div className="space-y-2">
            {Object.entries(stats.by_status || {}).map(([s, c]) => (
              <div key={s} className="flex justify-between text-sm">
                <span className="uppercase tracking-widest text-hyd-text2">{s}</span>
                <span className="text-hyd-gold font-bold">{c}</span>
              </div>
            ))}
            {Object.keys(stats.by_status || {}).length === 0 && <div className="text-hyd-text3 text-sm">No orders yet</div>}
          </div>
        </div>
        <div className="bg-hyd-panel border border-hyd-border rounded-xl p-4">
          <h3 className="font-display text-lg font-bold mb-3">Top products</h3>
          <div className="space-y-2">
            {(stats.top_products || []).map((p, i) => (
              <div key={i} className="flex justify-between text-sm">
                <span className="text-hyd-text2 line-clamp-1">{p.name}</span>
                <span className="text-hyd-gold font-bold">{p.qty} sold</span>
              </div>
            ))}
            {(stats.top_products || []).length === 0 && <div className="text-hyd-text3 text-sm">No sales yet</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
